export const filterRecordingVersionDetailsFromAsset = (assetVersionDetails = []) => (
  assetVersionDetails
    .filter(({ status, requestedResources }) => (
      status === 'COMPLETED'
      && requestedResources.some(({ resourceType }) => resourceType === 'recording')
    ))
);
